import cityDropDownHelper from '../../common/cityDropDownHelper';

const useZipcodeSearch = (setFormValues, setFormErrors) => {
  const fetchAddressByZipcode = async zipcode => {
    const cleanZip = zipcode.replace(/\D/g, '');
    if (cleanZip.length !== 8) return;

    try {
      const response = await fetch(
        `https://viacep.com.br/ws/${cleanZip}/json/`,
      );

      if (!response.ok) {
        throw new Error('Error fetching CEP');
      }

      const data = await response.json();

      if (data.erro) {
        setFormErrors(prev => ({
          ...prev,
          zipcodeError: 'CEP não encontrado. Verifique os números digitados.',
        }));
        return;
      }

      let mappedCity = data.localidade;

      const isAbrantesDistrict =
        data.localidade === 'Camaçari' &&
        data.bairro &&
        data.bairro.toLowerCase().includes('abrantes');

      if (isAbrantesDistrict) {
        mappedCity = 'Vila de Abrantes';
      }

      const supportedCity = cityDropDownHelper.cities.find(
        city => city.trim().toLowerCase() === mappedCity.trim().toLowerCase(),
      );

      if (!supportedCity) {
        setFormErrors(prev => ({
          ...prev,
          zipcodeError: 'Infelizmente ainda não atendemos nesta região.',
        }));
        return;
      }

      setFormValues(prev => ({
        ...prev,
        addressLine1: data.logradouro || prev.addressLine1,
        neighborhood: data.bairro || prev.neighborhood,
        city: supportedCity,
      }));

      setFormErrors(prev => ({
        ...prev,
        zipcodeError: '',
        cityError: '',
        addressLine1Error: data.logradouro ? '' : prev.addressLine1Error,
        neighborhoodError: data.bairro ? '' : prev.neighborhoodError,
      }));
    } catch (error) {
      console.error('Zipcode search failed:', error);
      setFormErrors(prev => ({
        ...prev,
        zipcodeError:
          'Tivemos um problema ao buscar o CEP. Por favor, tente novamente.',
      }));
    }
  };

  return { fetchAddressByZipcode };
};

export default useZipcodeSearch;
